import createLucideIcon from '../createLucideIcon';

const CheckCircle = createLucideIcon('CheckCircle', [
  ['path', { d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14', key: 'g774vq' }],
  ['polyline', { points: '22 4 12 14.01 9 11.01', key: '6xbx8j' }],
]);

export default CheckCircle;
